import axios from 'axios';
import Vue from 'vue';

/**
 * @method connectBzbsGet
 * @method connectBzbsPost
 */
export default {
    /**
     * Connect Buzzebees GET method
     * @param {string} url string url
     * @param {string} token (optional)
     * @param {object} data (optional)
     * @return Promise
     */
    connectBzbsGet: function (url, token, data) {
        var header = {
            'App-Id': Vue.bzbsConfig.client_id,
        };
        if (data == null) {
            data = {};
        }
        // data.device_app_id = this.config().client_id;
        if (token != null) {
            header.Authorization = 'token ' + token;
        }
        return axios({
            method: 'get',
            url: url,
            params: data,
            headers: header,
        });
    },

    /**
     * Connect Buzzebees POST method
     * @param {string} url string url
     * @param {string} token (optional)
     * @param {object} data parameter
     * @param {string} uploadKey (optional)
     * @param {object} uploadfile (optional)
     * @return Promise
     */
    connectBzbsPost: function (url, token, data, uploadKey, uploadfile) {
        var header = {
            'App-Id': Vue.bzbsConfig.client_id,
        };
        // data.device_app_id = this.config().client_id;
        var form = this.arrToFormData(data);
        if (uploadKey)
            form.append(uploadKey, uploadfile);

        if (token != null) {
            header.Authorization = 'token ' + token;
        }

        return axios({
            method: 'post',
            url: url,
            data: form,
            headers: header,
        });
    },

    /**
     * Connect Buzzebees POST method
     * @param {string} url string url
     * @param {string} token (optional)
     * @param {object} data parameter
     * @return Promise
     */
     connectBzbsPostJson: function (url, token, data) {
        var header = {
            'App-Id': Vue.bzbsConfig.client_id,
        };
        if (token != null) {
            header.Authorization = 'token ' + token;
        }
        return axios({
            method: 'post',
            url: url,
            data: data,
            headers: header,
        });
    },

    /**
     * Convert data to array of FormData
     * @param {Array|Dictionary} arr
     */
    arrToFormData: function (arr) {
        var form = new FormData();
        for (var i in arr) {
            form.append(i, arr[i]);
        }
        return form;
    },
    connectBzbsGetBlob: function (url) {
        return axios({
            method: 'get',
            url: url,
        });
    },
}
